/**
 * Simple pluralization helper
 * @param {number} count - The count to determine singular/plural
 * @param {string} singular - The singular form of the word
 * @param {string} plural - The plural form (defaults to singular + 's')
 * @returns {string} The appropriate singular or plural form
 */
export function pluralize(count, singular, plural = `${singular}s`) {
  return count === 1 ? singular : plural
}
